module.exports = __webpack_public_path__ + "img/20191209_111729-1.0d4a4127.jpg";